(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/christmas2023/christmas.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/christmas2023/christmas.js');
"use strict";


const {
  Fragment
} = React;
const christmas2023Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/christmas2023");
const bottomFrameImgsBack = [{
  imgSrc: "".concat(christmas2023Path, "/snow-back-01.png"),
  classNames: 'bottom-christmas-snow-back snow-back-01',
  id: 'snow-back-01'
}];
const bottomFrameImgs = [{
  imgSrc: "".concat(christmas2023Path, "/snow-front-03.png"),
  classNames: 'bottom-christmas-snow-back bottom-frame-left-cloud',
  id: 'christmas-snow-back snow-back-03'
}, {
  imgSrc: "".concat(christmas2023Path, "/bock.png"),
  classNames: 'bottom-frame-left-christmas-goat',
  id: 'goat'
}, {
  imgSrc: "".concat(christmas2023Path, "/tree.png"),
  classNames: 'bottom-frame-left-christmas-tree-1',
  id: 'tree-1'
}, {
  imgSrc: "".concat(christmas2023Path, "/tree.png"),
  classNames: 'bottom-frame-left-christmas-tree-2',
  id: 'tree-2'
}, {
  imgSrc: "".concat(christmas2023Path, "/snow-front-02.png"),
  classNames: 'bottom-christmas-snow-back bottom-frame-right-cloud',
  id: 'snow-back-02'
}, {
  imgSrc: "".concat(christmas2023Path, "/elf.png"),
  classNames: 'bottom-frame-right-christmas-elf',
  id: 'elf'
}, {
  imgSrc: "".concat(christmas2023Path, "/tomtemor.png"),
  classNames: 'bottom-frame-right-christmas-tomtemor',
  id: 'tomtemor'
}];
const BottomFrame = () => React.createElement("div", {
  className: "christmas-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "christmas-bottom-layers relative col-md-12"
}, bottomFrameImgs.map(_ref => {
  let {
    imgSrc,
    classNames = '',
    id
  } = _ref;
  return React.createElement("img", {
    alt: "jul-ram",
    className: "".concat(classNames),
    key: id,
    src: imgSrc
  });
})));
const BottomFrameBack = () => React.createElement("div", {
  className: "christmas-bottom-frame-back row pointer-none"
}, React.createElement("div", {
  className: "christmas-bottom-layers relative col-md-12"
}, bottomFrameImgsBack.map(_ref2 => {
  let {
    imgSrc,
    classNames = '',
    id
  } = _ref2;
  return React.createElement("img", {
    alt: "jul-ram",
    className: "".concat(classNames),
    key: id,
    src: imgSrc
  });
})));
const TopFrame = () => React.createElement("div", {
  className: "christmas-top-frame row pointer-none"
}, React.createElement("div", {
  className: "christmas-top-frame-container relative col-md-12"
}, React.createElement("img", {
  alt: "jul-ram",
  className: "christmas-top-frame-snow",
  src: "".concat(christmas2023Path, "/snow-top.png")
})));
const Christmas = _ref3 => {
  let {
    children,
    showTop = true,
    showBottom = true
  } = _ref3;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrameBack, null), showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.christmas2023.Christmas', Christmas);

 })(window);